import { createBrowserRouter } from 'react-router-dom';

import * as Sentry from '@sentry/react';
import routes from '@webclient/router/routes';

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

const router = sentryCreateBrowserRouter(routes, {
  future: {
    v7_skipActionErrorRevalidation: true,
    v7_partialHydration: true,
    v7_normalizeFormMethod: true,
    v7_fetcherPersist: true,
    v7_relativeSplatPath: true,
  },
});

export default router;
